import { useStripeCouponsStore } from '@/stores/stripeCoupons'
import type { NavigationGuardNext, RouteLocationNormalizedGeneric } from 'vue-router'

export async function stripeCouponCapture(
  to: RouteLocationNormalizedGeneric,
  _from: RouteLocationNormalizedGeneric,
  next: NavigationGuardNext,
) {
  const code = to.query.promoCode as string
  if (code) {
    const stripeCouponsStore = useStripeCouponsStore()
    stripeCouponsStore.savePromoCode(code)
  }

  next()
}
